/**
 * /dashboard/performance/feedback — Continuous feedback workspace.
 *
 * Migration note: port of
 * frontend/src/app/(dashboard)/dashboard/performance/feedback/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PerformanceModuleShell } from "@/components/shared/performance-module-shell";
import { PerformanceFeatureGate } from "@/components/performance/performance-feature-gate";
import { FeedbackTab } from "@/components/performance/feedback-tab";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/performance/feedback",
)({
  component: PerformanceFeedbackRoute,
});

function PerformanceFeedbackRoute() {
  return (
    <PerformanceModuleShell
      title="Continuous feedback"
      description="Give, request and review feedback across your team."
    >
      <PerformanceFeatureGate>
        <FeedbackTab />
      </PerformanceFeatureGate>
    </PerformanceModuleShell>
  );
}
